var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBiguser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 234,
    viewBox: "0 0 214 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M207.188 248.625h-27.626a13.812 13.812 0 0 1 0-27.625h13.813v-43.095a26.651 26.651 0 0 0-9.563-20.136 26.669 26.669 0 0 0-21.515-5.832l-42.543 38.123a13.814 13.814 0 0 1-18.508 0l-42.543-38.123a26.666 26.666 0 0 0-28.502 14.852 26.66 26.66 0 0 0-2.576 11.116V221h96.687a13.812 13.812 0 1 1 0 27.625h-110.5A13.814 13.814 0 0 1 0 234.812v-56.907a54.425 54.425 0 0 1 44.278-53.265 54.434 54.434 0 0 1 24.785 1.053 16.036 16.036 0 0 1 5.386 3.039l36.051 32.321 35.913-32.321a16.018 16.018 0 0 1 5.525-3.039A54.426 54.426 0 0 1 221 177.905v56.907a13.81 13.81 0 0 1-13.812 13.813z",
    fill: "#303030",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.5 138.125a69.06 69.06 0 0 1-67.736-82.536 69.062 69.062 0 1 1 67.736 82.536zm0-110.5a41.437 41.437 0 1 0 0 82.873 41.437 41.437 0 0 0 0-82.873z",
    fill: "#303030",
    fillOpacity: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiguser);
export default __webpack_public_path__ + "static/media/biguser.b0de737e90d9f963277065c377c125c2.svg";
export { ForwardRef as ReactComponent };